import React from 'react'
import { Modal } from 'react-bootstrap'
import { useState } from 'react'
import { ModalSolicitudMedicamento } from './ModalSolicitudMedicamento'
import { ModalListadoImportados } from './ModalListadoImportados'
import './ModalPopUpSolicitud.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark , faPhone} from '@fortawesome/free-solid-svg-icons';

export const ModalPopUpSolicitud = ({showModalPopUpSolicitud, handleCloseModalPopUpSolicitud, medicamento}) => {
    const [showModalSolicitudMedicamento, setShowModalSolicitudMedicamento] = useState(false)
    const [showModalListadoImportados, setShowModalListadoImportados] = useState(false)
    const [imageLoading, setImageLoading] = useState(true);

    const windowWidth = window.innerWidth;

    const goFormulario = () => {
        handleCloseModalPopUpSolicitud()
        setShowModalSolicitudMedicamento(true)
        
    }

    const verListado = () => {
        setShowModalListadoImportados(true) 
    }
    const Llamar = () => {
        window.location.href = "tel:+56931826931";
      }
    
    if (showModalSolicitudMedicamento) {
        return (
          <ModalSolicitudMedicamento showModalSolicitudMedicamento={showModalSolicitudMedicamento} handleCloseModalSolicitudMedicamento={goFormulario}/>
      )
      }else{
    return (
    <Modal show={showModalPopUpSolicitud} onHide={handleCloseModalPopUpSolicitud} size='lg' centered  style={{ width: '100%' }} > 
   
        <Modal.Body>
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <FontAwesomeIcon icon={faXmark} size='xl' onClick={handleCloseModalPopUpSolicitud} className='icon-stock'/>
            </div>
            <div className='row py-5 borde-modal'>
                <div className={`col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 ${windowWidth > 576 ? 'd-flex align-items-center ps-5' : 'text-center'}`} >
                        {/*Aqui va una imagen centrada */}
                        {imageLoading && <p>Cargando...</p>}
                        <img onLoad={() => setImageLoading(false)}  src='/importacion.png' alt='imagen importación' className='img-fluid' style={{ maxWidth: '250px', width: '100%', height: 'auto' }}/>
                </div>
                <div className={windowWidth < 576 ? 'col-12 col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 text-center pt-5' : 'col-12 col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 d-flex align-items-center'}>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 pb-3'>
                    <h3>Información Importante</h3>
                    </div>
                  
                    <div className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 ${windowWidth > 576 ? 'pe-5' : 'ps-4 pe-4'}`}>
                    <h5>Paso 1</h5>
                    <p>Completar el formulario adjuntando la receta.</p>
                    <h5>Paso 2</h5>
                    <p>Lo contactaremos para validar receta, solicitar otros documentos y enviaremos cotización para su aceptación.</p>
                    <h5>Paso 3</h5>
                    <p>Le informaremos cuando esté disponible para la compra en la farmacia o despacho a domicilio.</p>
                    </div>
                   
                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 text-center'>
                    <h6 className='pt-2'> <button className='boton-lpop' onClick={verListado}>Revisa aquí</button> Listado de últimos medicamentos importados</h6>
                    <button className={`popUp-boton ${windowWidth < 576 ? 'ancho-boton': null}`} onClick={()=>setShowModalSolicitudMedicamento(!showModalSolicitudMedicamento)}>Ir al formulario</button>
                    
                    </div>
                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 text-center'>
                    <button  className={`popUp-boton-telefono ${windowWidth < 576 ? 'ancho-boton': null}`} onClick={Llamar}>
                      <FontAwesomeIcon icon={faPhone} className="pe-2" />
                      +56931826931
                    </button>
                    <p className='pt-3'>
                      Horario de Atención: Lunes a Viernes 8:30 a 17:30 Hrs.
                    </p>
                  </div>
                    </div>
                  
                </div>
            </div>
        </Modal.Body>

 {
    showModalListadoImportados ? <ModalListadoImportados showModalListadoImportados={showModalListadoImportados} handleCloseModalListadoImportados={() => setShowModalListadoImportados(!showModalListadoImportados)}/> : null
 }
    </Modal>
  )
}
}
